// Contact.js

import React from "react";

import {
  Phone,
  Mail,
  MapPin,
  MessageCircle,
  BadgeInfo,
  Clock3,
  Send,
  ShieldCheck,
  Globe,
} from "lucide-react";

import "../Styles/contact.css";

import ContactForm from "../components/ContactForm";

const Contact = () => {

  return (
    <div className="modern-contact-page">

      {/* HERO */}
      <section className="modern-contact-hero">

        <div className="modern-contact-overlay" />

        <div className="modern-contact-hero-content">

          <div className="modern-contact-badge">
            CONTACT RCS
          </div>

          <h1 className="modern-contact-heading">
            Let’s Connect.
          </h1>

          <p className="modern-contact-text">
            We’re always ready to assist with
            your financial, payment and business
            needs across Guyana.
          </p>

        </div>

      </section>

      {/* MAIN SECTION */}
      <section className="modern-contact-main">

        {/* LEFT */}
        <div className="modern-contact-info-card">

          <div className="modern-contact-info-header">

            <div className="modern-contact-icon-main">
              <ShieldCheck size={34} />
            </div>

            <div>
              <h2>
                Get In Touch
              </h2>

              <p>
                Reach out to us anytime.
              </p>
            </div>

          </div>

          <div className="modern-contact-info-list">

            <div className="modern-contact-item">

              <div className="contact-item-icon">
                <Phone size={22} />
              </div>

              <div>
                <span>
                  Telephone
                </span>

                <p>
                  (592) 662-7987
                  <br />
                  (592) 649-1514
                </p>
              </div>

            </div>

            <div className="modern-contact-item">

              <div className="contact-item-icon">
                <Mail size={22} />
              </div>

              <div>
                <span>
                  Email
                </span>

                <p>
                  rcs@rcsgy.com.com
                </p>
              </div>

            </div>

            <div className="modern-contact-item">

              <div className="contact-item-icon">
                <MapPin size={22} />
              </div>

              <div>
                <span>
                  Address
                </span>

                <p>
                  22 Belle Plaine,
                  Wakenaam,
                  Essequibo
                </p>
              </div>

            </div>

            <a
              href="https://wa.me/5926627987"
              target="_blank"
              rel="noopener noreferrer"
              className="modern-social-link"
            >

              <MessageCircle size={22} />

              Message Us On WhatsApp

            </a>

            <a
              href="https://www.facebook.com/search/top?q=rcs%20top-up%20%26%20billing%20entity"
              target="_blank"
              rel="noopener noreferrer"
              className="modern-social-link"
            >

              <BadgeInfo size={22} />

              Visit Our Facebook Page

            </a>

          </div>

        </div>

        {/* RIGHT */}
        <div className="modern-contact-form-card">

          <div className="modern-form-header">

            <div className="modern-contact-icon-main green">
              <Send size={30} />
            </div>

            <div>
              <h2>
                Send A Message
              </h2>

              <p>
                We’ll get back to you
                as soon as possible.
              </p>
            </div>

          </div>

          <ContactForm />

        </div>

      </section>

      {/* HOURS */}
      <section className="modern-hours-section">

        <div className="modern-hours-card">

          <div className="modern-hours-top">

            <div className="modern-contact-icon-main gold">
              <Clock3 size={34} />
            </div>

            <div>
              <h2>
                Working Hours
              </h2>

              <p>
                Serving you throughout the week.
              </p>
            </div>

          </div>

          <div className="modern-hours-grid">

            <div className="modern-hour-box">

              <h3>
                Monday - Saturday
              </h3>

              <span>
                8:30 AM - 9:00 PM
              </span>

            </div>

            <div className="modern-hour-box">

              <h3>
                Sunday
              </h3>

              <span>
                1:00 PM - 5:30 PM
              </span>

            </div>

            <div className="modern-hour-box closed">

              <h3>
                Holidays
              </h3>

              <span>
                CLOSED
              </span>

            </div>

          </div>

        </div>

      </section>

    
    </div>
  );
};

export default Contact;